import { Injectable } from '@angular/core';
import {
  BehaviorSubject,
  distinctUntilChanged,
  fromEvent,
  map,
  partition,
  repeatWhen,
  shareReplay,
  startWith,
  Subject,
  takeUntil
} from 'rxjs'
import { Observable } from 'rxjs/internal/Observable'

@Injectable({
  providedIn: 'root'
})
export class IdleService {
  private ngUnsubscribe$: Subject<void> = new Subject<void>()
  private idleSubject$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  idle$ = this.idleSubject$.asObservable().pipe(distinctUntilChanged());
  idleStatusReported = false;

  whenPageVisible$() {
    const visibilitychange$ = fromEvent(
      document,
      'visibilitychange'
    )
      .pipe(
        startWith(document.visibilityState),
      map(() =>  document.visibilityState),
      distinctUntilChanged(), // Ensure only unique visibility state changes are processed
      shareReplay({ refCount: true, bufferSize: 1 }),
      takeUntil( this.ngUnsubscribe$),
    );

    const [pageVisible$, pageHidden$] = partition(
      visibilitychange$,
      (state) => state === 'visible'
    );

    visibilitychange$
      .subscribe((state: DocumentVisibilityState) => {
        const idle = state !== 'visible'
        if (idle && !this.idleStatusReported) {
          const lastActivityTime = new Date().toISOString();
          console.log(`Page became hidden at: ${lastActivityTime}`);
          this.idleStatusReported = true;
        }

        if (!idle && this.idleStatusReported) {
          this.idleStatusReported = false;
        }

        this.idleSubject$.next(idle)
      })

    return <T>(source: Observable<T>) => {
      return source.pipe(
        takeUntil( pageHidden$),
        repeatWhen(() => {
          return pageVisible$;
        })
      );
    }
  }

  stopIdleDetection$(): void {
    this.ngUnsubscribe$.complete()
  }

  checkIfIdle$(): Observable<boolean> {
    return this.idle$
  }
}
